import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_71: DocMigration = {
  maxSchemaVersion: "0.0.71",
  description: "Refactor dormers.sides from an array to a single side value",
  apply(json: any) {
    for (const roofId in json.roofs) {
      const roof = json.roofs[roofId];

      if (roof.sides && Array.isArray(roof.sides)) {
        const [side] = roof.sides;
        roof.side = side;
        delete roof.sides;
        json.roofs[roofId] = roof;
      }
    }
    return json;
  },
};

export default migration_0_0_71;
